import React from "react";
import { ShieldCheck } from "lucide-react"; // Import shield icon

const RERAApprovalSection = () => {
  return (
    <div className="max-w-5xl mx-auto p-6">
      {/* RERA Approved Card */}
      <div className="bg-gray-100 p-6 rounded-lg flex justify-between items-center border border-gray-200">
        {/* Left Side - Content */}
        <div className="flex-1">
          <h2 className="text-xl font-bold">RERA Approved</h2>

          <h3 className="text-lg font-semibold mt-2">What is RERA?</h3>
          <p className="text-gray-600 mt-1">
            The Real Estate (Regulation and Development) Act, 2016 is an Act of
            the Parliament of India, which seeks to protect buyers as well as
            help boost investments in the real estate industry. The Act came
            into force on <span className="font-semibold">1 May 2016</span>.
          </p>

          <h3 className="text-lg font-semibold mt-4">RERA ID</h3>
          <p className="text-blue-600 font-medium">RAJ/P/2024/3341</p>
        </div>

        {/* Right Side - RERA Icon */}
        <div className="w-20 h-20 bg-green-500 text-white rounded-full flex items-center justify-center">
          <ShieldCheck size={40} />
        </div>
      </div>
    </div>
  );
};

export default RERAApprovalSection;
